import { render, staticRenderFns } from "./PreviewRelease.vue?vue&type=template&id=178a797a&lang=pug&"
import script from "./PreviewRelease.vue?vue&type=script&lang=js&"
export * from "./PreviewRelease.vue?vue&type=script&lang=js&"
import style0 from "./PreviewRelease.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('178a797a')) {
      api.createRecord('178a797a', component.options)
    } else {
      api.reload('178a797a', component.options)
    }
    module.hot.accept("./PreviewRelease.vue?vue&type=template&id=178a797a&lang=pug&", function () {
      api.rerender('178a797a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/PreviewRelease.vue"
export default component.exports